// extracted by mini-css-extract-plugin
module.exports = {"pulseButton":"styles_pulseButton__Ygngw","pulse":"styles_pulse__2ufZw","noPulseButton":"styles_noPulseButton__JXAiy","micIcon":"styles_micIcon__17LCf"};